import { writable } from 'svelte/store';


//message enums

const MESSAGE_ENUM = Object.freeze({
    timeUpdate: 0,
    CountUpdate: 1,
    LogUpdate: 2,
    CanvasData: 3,
    snapMessage: 7
})


//generic info

export const visitors = writable("LOADING VISITORS!");

export const snapLogs = writable([]);

export const snaps = writable([]);

const snapImages = new Map();

export const currentSnapImage = writable("");

export const timeUpdate = writable("");





//socket stuff
//ws://127.0.0.1:7777/ws
const socket = new WebSocket("wss:drawboard.cafe/ws/");

export const messageStore = writable();

export const socketReady = writable(false);


socket.addEventListener('open', function (event) {
    console.log("Connected succesfully!");
    socketReady.set(true);
});

socket.addEventListener('close', function (event){
    console.log("lost connection!");
    socketReady.set(false);
})

// Listen for messages
socket.addEventListener('message', function (event) {
    let msg = JSON.parse(event.data);

    switch (msg.type) {

    case MESSAGE_ENUM.timeUpdate:
        timeUpdate.set(msg.time);
        break;

    case MESSAGE_ENUM.CountUpdate:
        visitors.set(msg.count);
        break;

    case MESSAGE_ENUM.LogUpdate:
        snapLogs.set(msg.logs);
        break;

    case MESSAGE_ENUM.snapMessage:
        snapImages.set(msg.id, msg.canvas_data);
        getSnapImage(msg.id);
        break;

    default:
        //rest is for canvas self, which can be determined on the spot
        messageStore.set(msg);
        break;
    }
});


export const getSnapImage = function(id){


    let potentialImage = snapImages.get(id);

    if (potentialImage == null){
        let message = {
            type: MESSAGE_ENUM.snapMessage,
            snap_id: id
        }
        sendMessage(message);
    }
    else{
        let to_set = snapImages.get(id);
        currentSnapImage.set(to_set);
    }

}


export const sendMessage = function(msg) {
    socket.send((JSON.stringify(msg)));
}

export const messageArray = writable([]);

export const currentColor = writable([255,0,0]);

export const brushSize = writable(10);

export const opacity = writable(100);

export const pickingFromCanvas = writable(false);